import styled from 'styled-components';

export const ApplicationContent = styled.div`
  padding: 0 48px;
`;
